import React, { useRef, useState } from "react";
import OcButton from "../components/OcButton";
import WaitlistModal from "../components/WaitlistModal";
import useOcReveal from "../useOcReveal";
import "./People.scss";

import circles from "../../../assets/images/home/02-people/space-circles-background.svg";
import astronaut1 from "../../../assets/images/home/02-people/grady-astronaut-1.png";
import astronaut2 from "../../../assets/images/home/02-people/grady-astronaut-2.png";
import photoTinkerers from "../../../assets/images/home/02-people/photo-ai-tinkerers.webp";
import photoBuilders from "../../../assets/images/home/02-people/photo-builders-and-creators.webp";
import photoLearners from "../../../assets/images/home/02-people/photo-learners-and-upskillers.webp";
import photoTeams from "../../../assets/images/home/02-people/photo-teams-and-partners.webp";

const Persona = ({ pos, reverse, photo, title, delay, children }) => (
  <div
    className={`people-persona people-persona--${pos} oc-reveal${reverse ? " people-persona--reverse" : ""}`}
    style={delay ? { "--oc-delay": delay } : undefined}
  >
    <div className="people-persona__photo">
      <img src={photo} alt={title} loading="lazy" decoding="async" />
    </div>
    <div className="people-persona__text">
      <p className="people-persona__title">{title}</p>
      <p className="people-persona__desc">{children}</p>
    </div>
  </div>
);

export default function People() {
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const sectionRef = useRef(null);
  useOcReveal(sectionRef);

  return (
    <section className="people" id="community" ref={sectionRef}>
      <img className="people__circles" src={circles} alt="" aria-hidden="true" />
      <img className="people__astronaut people__astronaut--1" src={astronaut1} alt="" aria-hidden="true" />
      <img className="people__astronaut people__astronaut--2" src={astronaut2} alt="" aria-hidden="true" />

      <Persona pos="tinkerers" photo={photoTinkerers} title="AI Tinkerers" delay="0.08s">
        You have tried the tools, prompts, and experiments, but want more structure.
      </Persona>
      <Persona pos="builders" reverse photo={photoBuilders} title="Builders and creators" delay="0.08s">
        You want to turn ideas, drafts, and experiments into something you can actually ship.
      </Persona>
      <Persona pos="learners" photo={photoLearners} title="Learners and upskillers" delay="0.16s">
        You want to build practical AI fluency through guided practice and real tasks.
      </Persona>
      <Persona pos="teams" reverse photo={photoTeams} title="Teams and partners" delay="0.16s">
        You want to bring AI learning, workshops, and tools to your own community.
      </Persona>

      <div className="people__center oc-reveal">
        <div className="people__center-text">
          <h2>For people ready to do more with AI</h2>
          <p>
            Open Campus is for learners, builders, creators, and teams who have been experimenting
            with AI and want a clearer path toward real output.
          </p>
        </div>
        <OcButton variant="primary" onClick={() => setWaitlistOpen(true)}>
          See workshops &amp; AI Fast Track
        </OcButton>
      </div>

      {/* Same AI Fast Track waitlist as the Hero "Join the first AI Fast Track cohort" CTA */}
      <WaitlistModal
        open={waitlistOpen}
        onClose={() => setWaitlistOpen(false)}
        variant="fastTrack"
      />
    </section>
  );
}
